import React from 'react'

import AiCard from './Components/AiCard/AiCard'
import FreelancerCard from './Components/FreelancerCard/FreelancerCard'

function PromoCards() {
  return (
    <div className="promo-cards">
      <AiCard />
      <FreelancerCard />
    </div>
  )
}

export default PromoCards
